import React from 'react';
import { Panel, ButtonToolbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PagedEntitiesList from '../../common/components/PagedEntitiesList';
import ui from '../../common/services/ui';
import { withTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faEye } from '@fortawesome/free-regular-svg-icons';

const List = ({ currentUser, canImpersonate, frontOfficeUrl, isReadonly, canSendMessage, listActions, t, ...rest }) => {
	const columns = [
		{
			header: t('Parent_Parent'),
			accessor: 'fullName',
			sortable: true
		},
		{
			header: t('Parent_Children'),
			accessor: 'children',
			sortable: false,
			cell: children => children.map(x => x.fullName).join(', ')
		},
		{
			header: t('Parent_City'),
			accessor: 'city',
			sortable: true
		},
		{
			header: t('Parent_Email'),
			accessor: 'email',
			sortable: true
		},
		{
			header: t('Parent_PhoneNumber'),
			accessor: 'phoneNumber',
			sortable: true
		},
		{
			header: t('Parent_IsOnline'),
			accessor: 'isOnline',
			cell: (isOnline) => (ui.formatBoolean(isOnline)),
			sortable: true
		},
		{
			header: t('Parent_Created'),
			accessor: 'created',
			cell: (created) => (ui.formatDateTime(created)),
			sortable: true
		},
		{
			header: t('Common_Actions'),
			accessor: 'id',
			cell: (id, row) => (<ButtonToolbar>
				<Link to={`/parents/${id}`} className='btn btn-teal' style={{ marginBottom: '5px' }}><FontAwesomeIcon icon={isReadonly ? faEye : faEdit} /> {t(isReadonly ? 'Common_View' : 'Common_Edit')}</Link>
				{canImpersonate && <a href={`${frontOfficeUrl}/impersonate?i=${encodeURIComponent(row.username)}&o=${encodeURIComponent(currentUser.username)}`}
					target='blank' className='btn btn-orange'>{t('Parent_LoginAsUser')}</a>}
			</ButtonToolbar>)
		}
	];

	return (
		<Panel>
			<Panel.Body>
				<PagedEntitiesList columns={columns} checkboxSelection={canSendMessage} listActions={listActions} {...rest} />
			</Panel.Body>
		</Panel>
	);
};
//	<ListActions isReadonly={isReadonly} newItemPath='/parents/new' />
export default withTranslation()(List);